import { Outlet } from "react-router-dom";

function Inbox() {
  return <Outlet />;
}

export default Inbox;
